<template>
  <div class="login">
    <h2>释空文件存储中心</h2>
    <div class="login-form">
      <el-form v-model="form" label-position="left" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            type="password"
            v-model="form.password"
            @change="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="btn-login">
            <el-button type="primary" @click="onSubmit">立即登录</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      redirect: null,
    };
  },
  mounted() {
    this.redirect = this.$route.query.redirect;
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("login", this.form).then((res) => {
        if (res.code == 200) {
          // localStorage.setItem("user", JSON.stringify(res.user))
          // localStorage.setItem("token", res.token)
          this.$router.push({ path: this.redirect || "/" });
        }
      });
    },
  },
};
</script>
<style>
.login {
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.login-form {
  border: 1px solid #ccc;
  padding: 22px;
  border-radius: 5px;
  width: 18%;
  background: #fff;
}
.btn-login {
  width: 100%;
}
.btn-login .el-button {
  width: 100%;
}
</style>
